export interface JiraIssue {
  fields: {
    project: {
      key: string;
    };
    summary: string;
    description: string;
    issuetype: {
      name: string;
    };
    priority: {
      name: string;
    };
    reporter?: {
      emailAddress?: string;
      displayName?: string;
    };
  };
}

export interface JiraIssueRequest {
  title: string;
  description: string;
  priority: JiraPriority;
  reporterEmail?: string;
  reporterName?: string;
  attachments?: File[];
}

export enum JiraPriority {
  HIGHEST = 'Highest',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
  LOWEST = 'Lowest'
}

export interface JiraCreateIssueResponse {
  id: string;
  key: string;
  self: string;
}
